import styled from 'styled-components';
import ds, { media } from 'designsystem';

const LanguageFullWidthBar = styled.div`
  display: none;

  ${media.desktop`
    display: block;
    position: absolute;
    width: 200vw;
    left: -100vw;
    top: 0;
    height: ${ds.get('navSection.navHeight')};
    background-color: ${ds.brand('white')};
    transition-duration: 0.1s;
    pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};    
  `}
`;

export default LanguageFullWidthBar;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/LanguageFullWidthBar.jsx